<div class="triple-rows" stop-propagation>
  <div class="cell-row" style="position: relative">
    <div
      class="supplier-info-hover-container"
      [class.tooltip-open]="isTooltipOpen"
      [popper]="tooltipcontent"
      popperTrigger="click"
      [popperDelay]="delay"
      [popperPlacement]="position"
      [popperHideOnMouseLeave]="false"
      (popperOnShown)="onPopperShown()"
      (popperOnHidden)="onPopperHidden()"
      [popperApplyClass]="'w-[332px]' +
        (procurementScheme || campaignScheme
          ? 'product-chain-info-popover'
          : '')
      "
      popperAppendTo="app-root"
    >
      <!-- <span *ngIf="mainPriceScheme">T</span> -->
      <span class="product-invalid-sm-icon" *ngIf="hasInvalidValues"></span>
      <span
        class="product-procurement-sm-icon"
        *ngIf="procurementScheme"
      ></span>
      <span class="product-campaign-sm-icon" *ngIf="campaignScheme"> </span>
    </div>
  </div>

  <product-scheme-display-price
    [scheme]="scheme"
    [colored]="colored"
    [pricePrecision]="pricePrecision"
    [displayPriceField]="displayPriceField"
    class="cell-row"
  >
  </product-scheme-display-price>

  <div class="cell-row">
    <product-locations-info
      *ngIf="locations?.length"
      [showValidationWall]="hasInvalidValues"
      [validationUrl]="validationUrl"
      [retailerName]="retailerName"
      [locations]="locations"
    ></product-locations-info>
    <!-- <ng-content></ng-content> -->
  </div>
</div>

<popper-content #tooltipcontent (click)="preventPropagation()">
  <!-- INVALID VALUES SECTION -->
  <div
    class="popover-section"
    *ngIf="hasInvalidValues"
    [class.mb20]="procurementScheme || campaignScheme"
  >
    <div class="popover-section-header">
      <span class="product-invalid-icon"></span>
      <span class="popover-section-header-text ml10">
        {{
          "cards.products.product_price_info_popover.product_has_invalid_values"
            | translate
        }}
      </span>
    </div>

    <p
      class="popover-section-row mb-4 mt-3 font-text text-sm font-normal text-grey-100"
    >
      {{
        "cards.products.product_price_info_popover.invalid_values_with_retailerName"
          | translate: { retailerName: retailerName }
      }}
    </p>

    <ng-container *ngIf="validationUrl">
      <ng-container *requiredModules="['SellerPimExtensions']">
        <lxm-button
          (click)="navigateToProductValidation()"
          type="beige"
          label="action.to_validate_product_card"
          class="w-max"
        >
          <svg-icon
            svg-icon-left
            key="acceptMonochrome"
            fontSize="14px"
          ></svg-icon>
        </lxm-button>
      </ng-container>
    </ng-container>
  </div>

  <!-- PROCUREMENT SECTION -->
  <div
    class="popover-section"
    *ngIf="procurementScheme"
    [class.mb20]="campaignScheme"
  >
    <div class="popover-section-header">
      <span class="product-procurement-icon"></span>
      <span class="popover-section-header-text ml10"
        >{{ procurementScheme.validFrom | formDate }} -
        {{ endDate(procurementScheme.validTo) | formDate }}</span
      >
    </div>
    <div class="popover-section-content">
      <div class="popover-section-row flex justify-between">
        <span class="mr20">
          {{
            "cards.products.product_price_info_popover.procurement_price"
              | translate
          }}
        </span>
        <span class="procurement-price">
          {{
            procurementPrice
              | priceValue: pricePrecision : procurementCurrency?.value
          }}
        </span>
      </div>
      <div class="popover-section-row flex justify-between">
        <span class="mr20">
          {{ "cards.products.product_price_info_popover.discount" | translate }}
        </span>
        <span class="chain-info-discount-percentage">
          {{ procurementDiscount | percentValue }}
        </span>
      </div>
    </div>
  </div>

  <!-- CAMPAIGN SECTION -->
  <div class="popover-section" *ngIf="campaignScheme">
    <div class="popover-section-header">
      <span class="product-campaign-icon"></span>
      <span class="popover-section-header-text ml10">
        {{ campaignScheme.validFrom | formDate }} -
        {{ endDate(campaignScheme.validTo) | formDate }}
      </span>
    </div>
    <div class="popover-section-content">
      <div class="popover-section-row flex justify-between">
        <span class="mr20">
          {{
            "cards.products.product_price_info_popover.campaign_price"
              | translate
          }}
        </span>
        <span class="campaign-price">
          {{
            campaignPrice | priceValue: pricePrecision : campaignCurrency?.value
          }}
        </span>
      </div>
      <div class="popover-section-row flex justify-between">
        <span class="mr20">
          {{
            "cards.products.product_price_info_popover.campaign_discount"
              | translate
          }}
        </span>
        <span class="campaign-discount-percentage">
          {{ campaignDiscount | percentValue }}
        </span>
      </div>
      <div class="popover-section-row flex justify-between">
        <span class="mr20">
          {{
            "cards.products.product_price_info_popover.retailer_price"
              | translate
          }}
        </span>
        <span>
          {{
            mainSchemeMainPrice
              | priceValue: pricePrecision : mainSchemeCurrency?.value
          }}
        </span>
      </div>
      <div class="popover-section-row flex justify-between">
        <span class="mr20">
          {{ "cards.products.product_price_info_popover.discount" | translate }}
        </span>
        <span class="chain-info-discount-percentage">
          {{ mainSchemeDiscount | percentValue }}
        </span>
      </div>
    </div>
  </div>
</popper-content>
